import React, { lazy, memo, Suspense } from "react";
import Loading from "@genericComponents/Loading.js";
const DataSelectControl = lazy(
  () => import("@controls/DataEntry/DataSelect/DataSelectControl.js"),
);
const DataSelect = ({
  state,
  name,
  data,
  tran = null,
  required = null,
  onChange = null,
  className = null,
  defaultnone = "137",
  capture = null,
  defaultselected = null,
  groupNone = "0",
  listStoreQuery = null,
  isOptionsClientSideOnly = false,
}) => {
  return (
    <Suspense fallback={<Loading />}>
      <DataSelectControl
        state={state}
        name={name}
        data={data}
        tran={tran}
        required={required}
        onChange={onChange}
        className={className}
        defaultnone={defaultnone}
        capture={capture}
        defaultselected={defaultselected}
        groupNone={groupNone}
        listStoreQuery={listStoreQuery}
        isOptionsClientSideOnly={isOptionsClientSideOnly}
      />
    </Suspense>
  );
};
export default memo(DataSelect);
